// removed by extract-text-webpack-plugin
module.exports = {"secret":"Secret__secret___24qjo","wrapper":"Secret__wrapper___Ho9g1","input":"Secret__input___280ND","submit":"Secret__submit___3I0AF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Secret/Secret.css
// module id = 934
// module chunks = 0